<div class="header cor-master">
    <div class="title">{{ titulo }}</div>
    <button class="close-button" mat-icon-button (click)="fecharDialog()">
        <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
</div>

<mat-dialog-content class="m-0 p-0 flex-col" *ngIf="deposito.status == null">
    <div class="flex flex-col m-0 p-4  pb-0 rounded overflow-hidden">
        <div class="flex flex-col ">
            <div class=" justify-center my-1">
                <div class="flex flex-col font-semibold text-xs text-center text-hint uppercase tracking-wider">
                    <span>Escolha entre os valores mais depositados</span>
                    <div class="flex justify-center">
                        <div (click)="deposito.valor = 10" class="botao-valor m-1 cursor-pointer">
                            <span class="font-semibold">R$10</span>
                        </div>
                        <div (click)="deposito.valor = 20" class="botao-valor m-1 cursor-pointer">
                            <span class="font-semibold">R$20</span>
                        </div>
                        <div (click)="deposito.valor = 50" class="botao-valor m-1 cursor-pointer">
                            <span class="font-semibold">R$50</span>
                        </div>
                        <div (click)="deposito.valor = 100" class="botao-valor m-1 cursor-pointer">
                            <span class="font-semibold">R$100</span>
                        </div>
                    </div>
                </div>
            </div>
            <mat-form-field class="flex-auto font-semibold self-center w-full">
                
                

                <input matInput class="font-semibold" type="text" inputmode="numeric" placeholder="Valor do depósito"
                    [(ngModel)]="deposito.valor" currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'Left'}" />
                    
                <mat-icon matPrefix [svgIcon]="'attach_money'"></mat-icon>
            </mat-form-field>

            <img class="max-h-30 max-w-30 self-center m-2" src="https://scorealarm-stats.freetls.fastly.net/app-assets/sds-logos/finance-pix-light.svg" alt="finance-pix">
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="deposito.status == 'Aberto'" class="m-0 flex-col" id="imprimir">
    <div class="m-2 max-w-80">
<div class="text-base text-secondary font-blinker text-center mb-4">Use seu App bancário ou carteira digital para escanear ou digitar o código Pix gerado</div>
    <img class="h-50 w-50 text-center" style="margin-left: auto; margin-right: auto; display: block;"
        src="{{deposito.imagemPix}}" alt="QR" />
    <button (click)="copiar(deposito.textoPix)" class="mr-2 mt-2 w-full "
        mat-flat-button>
        <mat-icon class="icon-size-20 mr-2" [svgIcon]="'file_copy'"></mat-icon>
        <span>Copiar código</span>
    </button>
    </div>
    

</mat-dialog-content>

<mat-dialog-content class="m-0 p-0 flex-col" *ngIf="deposito.status == 'Pago'">

    <div class="p-4" #imprimir>
        <div class="success-checkmark">
            <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
            </div>
        </div>
        <div class="text-xl text-semi-bold text-center"><b>DEPÓSITO REALIZADO COM SUCESSO!</b></div>
    </div>
</mat-dialog-content>

<div class="botoes shadow-xs" *ngIf="deposito.status == null">
    <!-- Discard -->
    <button mat-button class="mr-2 cancelar" mat-button (click)="fecharDialog()">
        <span>Cancelar</span>
    </button>

    <!-- Save as draft -->
    <button mat-flat-button [disabled]="deposito.valor < 1 || deposito.valor == null" *ngIf="!carregando" [ngClass]="{
            'gray-300': deposito.valor < 1 || deposito.valor == null,
            'green-600': deposito.valor >= 1

        }" (click)="salvar()" class="ml-2 mr-2">
        <span>Depósitar {{numeroParaReal(deposito.valor)}}</span>
    </button>
    <mat-progress-spinner class="mr-2 self-center" color="black" *ngIf="carregando" [diameter]="24"
        [mode]="'indeterminate'">
    </mat-progress-spinner>
</div>